





























import { Component, Vue } from 'vue-property-decorator'
import { buildInboxURL } from '@/services/oneweb'
import { pushAnalyticsEvent } from '@/services/utils'
import { EventDetail } from '@/config/interface'

@Component({
  name: 'inbox-redirect-button',
})
export default class InboxRedirectButtonComponent extends Vue {
  url = ''

  mounted(): void {
    this.url = buildInboxURL()
  }

  sendAnalytics(): void {
    const event: EventDetail = {
      category: 'link',
      action: 'header.notifications_&_messages',
      label: 'inbox',
      URL: this.url,
    }
    pushAnalyticsEvent(event)
  }
}
